module.exports = __webpack_public_path__ + "media/images/consumer/signup/payment/credit-card/visa-36b5d9ea7e749ebc16b4371faeed178a.png";